function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBedrooms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M29,29v-9.9c0-1.16-.94-2.1-2.1-2.1H5.1c-1.16,0-2.1,.94-2.1,2.1v9.9",
    style: {
      fill: "none",
      stroke: "#69757c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5,17v-5.54c0-2.39-1.94-4.33-4.33-4.33H10.83c-2.39,0-4.33,1.94-4.33,4.33v5.54",
    style: {
      fill: "none",
      stroke: "#69757c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 23,
    x2: 29,
    y2: 23,
    style: {
      fill: "none",
      stroke: "#69757c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.5,
    y1: 12,
    x2: 25.5,
    y2: 12,
    style: {
      fill: "none",
      stroke: "#69757c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 12,
    x2: 16,
    y2: 17,
    style: {
      fill: "none",
      stroke: "#69757c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.5px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedrooms);
export default __webpack_public_path__ + "static/media/bedrooms.8b8bc529b9c90cb95b85795b85709c06.svg";
export { ForwardRef as ReactComponent };